// One line about one scan, for the list in the maintenance panel. A plain function, so
// the part that has to be right is the part under test.
//
// The imports are written out rather than left to Nuxt, which is what lets the test
// load this file with plain Node.
import { DOOR_VERDICT_LABELS, badgeRef } from './doorEntry.ts'
import type { DoorScan, ScanStatus, StoredScan } from './scanStore.ts'

export interface ScanSummary {
  // The tail of the code, never a name.
  badge: string
  // What happened to the person.
  result: string
  // What happened to the record: whether we have been told about it.
  state: string
}

const STATE_LABELS: Record<ScanStatus, string> = {
  pending: 'Waiting',
  synced: 'Uploaded',
  rejected: 'Rejected',
  // Nothing is waiting to be sent for this one. See ScanStatus in the store.
  unrecorded: 'Not sent',
}

/**
 * What became of a badge at a door.
 *
 * The verdict alone is not the outcome: "Not registered" reads as somebody turned away,
 * and half the time they were waved in. A seat the server admitted on the spot says it
 * too, since to whoever reads this list that is the same event.
 */
const doorResult = (scan: DoorScan): string => {
  const verdict = DOOR_VERDICT_LABELS[scan.verdict ?? 'unverified']

  if (scan.action === 'admit' || (scan.action === 'check' && scan.admitted)) {
    return `${verdict} · let in`
  }

  if (scan.action === 'refuse') {
    return `${verdict} · turned away`
  }

  // A check nobody acted on: the person walked off, or the next badge replaced them.
  return verdict
}

export const summariseScan = (scan: StoredScan): ScanSummary => ({
  badge: badgeRef(scan.code),
  // The fallback is for a record from a phone never told its area name.
  result: scan.kind === 'door' ? doorResult(scan) : scan.areaName || 'Lead',
  state: STATE_LABELS[scan.status],
})
